import {
  queryHelpCenterByIdGuideList,
  queryAdvisoryEssayList,
  queryAdvisoryEssayById,
  queryHelpCenterByNameGuideList,
  queryQrcodesAndServicer,
  queryDiscountActivityList,
  queryDiscountActivityById,
  confirmActivityPrize,
  qiniuUpload,
  queryAnnounceEssayList,
  headImg,
  fetchAgentDesc,
  // queryThreadList
  queryDiscountInternational
} from "@/api/cms";

import {
  SET_CMS_SERVICER,
  SET_CMS_QRCODES,
  SAVE_CMS_DISCOUNTS,
  SAVE_AGENT_DESC
} from "@/store/mutation_types";
import util from "@/utils/util";

const cms = {
  state: {
    servicer: {
      url: ""
    },
    agentDesc: "",
    qrcodes: [],
    cmsDiscounts: []
  },
  getters: {
    cmsServicer: state => state.servicer,
    cmsServicerUrl: state => state.servicer.url,
    cmsQrcodeIOS: state => state.qrcodes[0] || {},
    cmsQrcodeAndroid: state => state.qrcodes[1] || {},
    cmsCurDiscounts: (state, getters) => {
      const cmsDiscounts = state.cmsDiscounts;
      // const key = getters.isInternational ? "ImgResourcePlatTypeInternational" : "lotCcGameTypeConfig";
      const key = "ImgResourcePlatTypeInternational";
      let curDiscountStr = null;
      for (let i in cmsDiscounts) {
        const cmsDiscount = cmsDiscounts[i];
        if (cmsDiscount.key === key) {
          curDiscountStr = cmsDiscount.value;
          break;
        }
      }
      try {
        return JSON.parse(curDiscountStr);
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    agentDesc: state => state.agentDesc
  },
  mutations: {
    [SET_CMS_SERVICER]: (state, data) => {
      state.servicer = data;
    },
    [SET_CMS_QRCODES]: (state, data) => {
      state.qrcodes = data;
    },
    [SAVE_CMS_DISCOUNTS](state, playload = []) {
      state.cmsDiscounts = playload;
    },
    [SAVE_AGENT_DESC](state, playload) {
      state.agentDesc = playload;
    }
  },
  actions: {
    async queryCmsHelpCenterByIdGuideList({ commit }, playload) {
      return await queryHelpCenterByIdGuideList(playload);
    },
    async queryCmsAdvisoryEssayList({ commit }, playload) {
      return await queryAdvisoryEssayList(playload.data, playload.config);
    },
    async queryCmsAdvisoryEssayById({ commit }, playload) {
      return await queryAdvisoryEssayById(playload);
    },
    async queryCmsHelpCenterByNameGuideList({ commit }, playload) {
      return await queryHelpCenterByNameGuideList(
        playload.data,
        playload.config
      );
    },
    async queryCmsQrcodesAndServicer({ commit, state }, playload) {
      // if (!state.servicer.url) {
      //   const resp = await queryQrcodesAndServicer(playload);
      //   const dt = resp.data.data;
      //   const { servicer } = dt;
      //   document.title = servicer.name;
      //   configText.main = servicer.name;
      //   commit(SET_CMS_SERVICER, servicer);
      // }
      // if (!state.qrcodes || !state.qrcodes.length) {
      //   const resp = await queryQrcodesAndServicer(playload);
      //   const dt = resp.data.data;
      //   const { qrcodes } = dt;
      //   commit(SET_CMS_QRCODES, qrcodes);
      // }
      // return state.servicer;
    },
    async queryCmsDiscountActivityList({ commit }, playload) {
      return await queryDiscountActivityList(playload);
    },
    async queryCmsDiscountActivityById({ commit }, playload) {
      return await queryDiscountActivityById(playload.data, playload.config);
    },
    async confirmCmsActivityPrize({ commit }, playload) {
      return await confirmActivityPrize(playload);
    },
    async qiniuCmsUpload({ commit }, playload) {
      return await qiniuUpload(playload.data, playload.config);
    },
    async queryCmsAnnounceEssayList({ commit }, playload) {
      return await queryAnnounceEssayList(playload);
    },
    async headImgCms({ commit }, playload) {
      return await headImg(playload.data, playload.config);
    },
    async queryDiscountInternational({ state, commit, dispatch }, playload) {
      const res = await queryDiscountInternational();
      if (res.data.code !== 0) return;
      commit(SAVE_CMS_DISCOUNTS, res.data.data);
      return res.data.data;
    },
    async fetchAgentDesc({ commit }) {
      const res = await fetchAgentDesc();
      commit(
        SAVE_AGENT_DESC,
        util.escapeHtml(res.data.data.map(item => item.content).join("\n"))
      );
    }
    // async queryThreadList({ commit }, playload) {
    //   return await queryThreadList(playload);
    // }
  }
};

export default cms;
